import { render } from "./SignTitle.vue?vue&type=template&id=a6a9c898&scoped=true"
const script = {}

import "./SignTitle.vue?vue&type=style&index=0&id=a6a9c898&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6a9c898"]])

export default __exports__